import css from 'styled-jsx/css';
import Theme, { colors, fontSizes } from '../../../themes';

const { buttons } = Theme.forms;

export default css`
  .link-button {
    align-items: center;
    border: 1px solid;
    display: flex;
    font-size: ${fontSizes.small};
    font-weight: 700;
    justify-content: center;
    padding: 10px;
    text-decoration: none;
    width: auto;
  }

  .with-border-radius {
    border-radius: 5px;
  }

  .primary {
    background: ${colors.greenOliveDark};
    border-color: ${colors.greenOliveDark} ${colors.greenOliveDark} #9b9b0d;
    color: ${colors.white};
  }

  .blue {
    background: ${buttons.blue.bg};
    border-color: ${buttons.blue.border};
    color: ${buttons.blue.color};
  }

  .orange {
    border-radius: 4px;
    background: ${buttons.orange.bg};
    border-color: ${buttons.orange.border};
    color: ${buttons.orange.color};
  }

  .flat {
    border: none;
    background: transparent;
    color: ${colors.blue};
    font-size: ${fontSizes.small};
    padding: 0 0 0 20px;
    text-transform: uppercase;
    width: auto;
  }

  @media (max-width: 374px) {
    .link-button {
      font-size: ${fontSizes.verySmall};
    }
  }
`;



// WEBPACK FOOTER //
// ./app/common/Links/LinkButton/styles.js